<template>
    <button @click="$parent.toggleMenu()">
        <svg
            v-if="!menuIsOpen"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 12.6499C2 12.0976 2.44772 11.6499 3 11.6499H21C21.5523 11.6499 22 12.0976 22 12.6499C22 13.2022 21.5523 13.6499 21 13.6499H3C2.44772 13.6499 2 13.2022 2 12.6499Z"
                fill="black"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 6.6499C2 6.09762 2.44772 5.6499 3 5.6499H21C21.5523 5.6499 22 6.09762 22 6.6499C22 7.20219 21.5523 7.6499 21 7.6499H3C2.44772 7.6499 2 7.20219 2 6.6499Z"
                fill="black"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 18.6499C2 18.0976 2.44772 17.6499 3 17.6499H21C21.5523 17.6499 22 18.0976 22 18.6499C22 19.2022 21.5523 19.6499 21 19.6499H3C2.44772 19.6499 2 19.2022 2 18.6499Z"
                fill="black"
            />
        </svg>

        <svg
            v-else
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.7071 7.35701C19.0976 6.96648 19.0976 6.33332 18.7071 5.9428C18.3166 5.55227 17.6834 5.55227 17.2929 5.9428L12 11.2357L6.70711 5.9428C6.31658 5.55227 5.68342 5.55227 5.29289 5.9428C4.90237 6.33332 4.90237 6.96648 5.29289 7.35701L10.5858 12.6499L5.29289 17.9428C4.90237 18.3333 4.90237 18.9665 5.29289 19.357C5.68342 19.7475 6.31658 19.7475 6.70711 19.357L12 14.0641L17.2929 19.357C17.6834 19.7475 18.3166 19.7475 18.7071 19.357C19.0976 18.9665 19.0976 18.3333 18.7071 17.9428L13.4142 12.6499L18.7071 7.35701Z"
                fill="black"
            />
        </svg>
    </button>
</template>

<script>
export default {
  name: "HeaderHamburgerButton",
  props: {
    menuIsOpen: {
      type: Boolean,
    },
  }
}
</script>
